import { Box, CircularProgress, Typography } from '@mui/material';

function Loading() {
  return (
    <Box 
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        gap: 2
      }}
    >
      <CircularProgress 
        color="primary"
        sx={{ 
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
          }
        }} 
      />
      <Typography 
        variant="h6" 
        sx={{ 
          color: 'text.secondary',
          fontWeight: 500
        }}
      >
        Chargement...
      </Typography>
    </Box>
  );
}

export default Loading; 